<!--
 * @Author: etong
 * @Date: 2021-07-05 15:07:17
 * @LastEditTime: 2023-07-04 18:00:45
 * @LastEditors: your name
 * @Description:
 * @FilePath: \oak\src\components\JJForm\noInFormItem.vue
 * Think first, Program later
-->
<template>
  <el-input
    v-if="item.type==='input'"
    v-bind="$attrs"
    :type="item.subtype"
    :placeholder="item.placeholder || ''"
    :style="{width: item.width || '180px'}"
    v-on="$listeners"
  />

  <input-number
    v-else-if="item.type==='number'"
    v-bind="$attrs"
    v-on="$listeners"
  />

  <el-checkbox
    v-else-if="item.type==='switch' && item.appearance==='checkbox'"
    v-bind="$attrs"
    v-on="$listeners"
  >
    {{ item.label }}
  </el-checkbox>

  <el-switch
    v-else-if="item.type==='switch'&& item.appearance!=='checkbox'"
    v-bind="$attrs"
    v-on="$listeners"
  />

  <el-radio-group
    v-else-if="item.type==='radio'"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <component
      :is="item.button?'el-radio-button':'el-radio'"
      v-for="o in item.options||ajaxOptions"
      :key="o.value"
      :label="o.value"
      :disabled="o.disabled"
      :border="item.border"
    >{{ o.label }}</component>
  </el-radio-group>

  <el-checkbox-group
    v-else-if="item.type==='checkbox'"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <component
      :is="item.button?'el-checkbox-button':'el-checkbox'"
      v-for="o in item.options||ajaxOptions"
      :key="o.value"
      :disabled="o.disabled"
      :label="o.value"
      :border="item.border"
    >{{ o.label }}</component>
  </el-checkbox-group>
  <el-select
    v-else-if="item.type==='select'"
    v-bind="Object.assign({}, $attrs, {value: undefined})"
    :value="normalizedSelectValue"
    :class="item.class"
    :placeholder="item.placeholder || ''"
    :remote="item.remote?true:false"
    :remote-method="item.remote?(query)=>{getAjaxOptions(query,item)}:()=>{}"
    :style="{width: item.width || '150px'}"
    popper-class="common-select-popper"
    v-on="$listeners"
    @change="(val) => handleSelectChange(item,val)"
  >
    <el-option
      v-for="o in selectOptions"
      :key="o.strValue"
      :label="o.strKey"
      :value="o.strValue"
      :disabled="o.disabled || false"
    />
  </el-select>
  <el-time-picker
    v-else-if="item.type==='time'"
    :format="item.format"
    v-bind="$attrs"
    range-separator="至"
    start-placeholder="开始时间"
    end-placeholder="结束时间"
    style="width: 100%"
    v-on="$listeners"
  />

  <!-- :format="item.format"
    :value-format="item['value-format']" -->
  <el-date-picker
    v-else-if="item.type==='date'"
    :type="item.subtype"
    :format="item.viewFormat||item.valueFormat"
    :placeholder="item.placeholder || ''"
    :value-format="item['value-format'] || item.valueFormat"
    :value="processedValue"
    v-bind="Object.assign({}, $attrs, {value: undefined})"
    :style="{width: item.width || '220px'}"
    range-separator="至"
    start-placeholder="开始时间"
    end-placeholder="结束时间"
    v-on="$listeners"
  />

  <UploadFile
    v-else-if="item.type==='file'"
    v-bind="$attrs"
    v-on="$listeners"
    @changeFile="changeFile"
  />
  <el-input
    v-else-if="item.type==='hidden'"
    v-bind="$attrs"
    type="hidden"
    style="display:none"
    v-on="$listeners"
  />
  <span v-else>未知控件类型</span>
</template>

<script>

import UploadFile from '@/components/UploadFile'
import { createValueFormatConverter } from '@/utils/lowcode/plugins/ValueFormatConverter'
import {
  EexcuteDataSource
} from '@/api/system'
import { JJFormFormatterMixin } from '@/utils/lowcode/mixins/FormatterMixin' // 统一格式化mixin

export default {
  name: 'JJnoInFormItem',
  components: {
    UploadFile
  },
  directives: {
  },
  mixins: [JJFormFormatterMixin],
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      ajaxOptions: []
    }
  },
  computed: {
    Rules() {
      const { item: { rules }} = this
      if (rules === undefined) return undefined

      const R = []

      rules.forEach(rule => {
        R.push(rule)
      })

      return R
    },
    selectOptions() {
      const { item, ajaxOptions } = this
      if (!('options' in item)) {
        item.options = []
      }
      const result = (item.options.length > 0 && item.options) || (ajaxOptions.length > 0 && ajaxOptions) || []
      return result
    },

    // 🎯 双向转换：将formValue反向解析为select组件需要的格式
    // @author domiyong
    normalizedSelectValue() {
      try {
        const { item, $attrs } = this

        // 安全检查：确保必要的属性存在
        if (!item || !$attrs) {
          return undefined
        }

        const formValue = $attrs.value

        // 单选直接返回原值
        if (!item.multiple) {
          return formValue
        }

        // 多选需要反向解析成数组格式
        if (typeof this.parseFormValueToSelectArray === 'function') {
          return this.parseFormValueToSelectArray(formValue, item)
        } else {
          // 降级处理：如果方法不存在，返回空数组或原值
          return Array.isArray(formValue) ? formValue : []
        }
      } catch (error) {
        console.warn('[JJForm noInForm] normalizedSelectValue 计算失败:', error)
        return this.$attrs && this.$attrs.value ? this.$attrs.value : undefined
      }
    }
    // 🎯 日期动态配置处理 - 已迁移到JJFormFormatterMixin
    // processedValue计算属性现在由JJFormFormatterMixin提供，消除代码重复
  },
  watch: {},
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    // this.getAjaxOptions()
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    const { remote, value, options, isSelectLinked } = this.item
    // 如果下拉框有默认值 或者 远程搜索有默认下拉列表 会调用获取数据源接口
    if ((!remote && !isSelectLinked) || (remote && (value || options))) {
      this.timer = setTimeout(this.getAjaxOptions, 200)
    }
  },
  destroyed() {
    clearTimeout(this.timer)
  },
  methods: {
    /**
     * @description: 反向解析：将formValue转换为select组件需要的数组格式
     * @author domiyong
     * @param {*} formValue - 来自父组件的值
     * @param {Object} item - 表单项配置
     * @return {Array} select组件需要的数组格式值
     */
    parseFormValueToSelectArray(formValue, item) {
      const outputFormat = item.outputFormat || 'string'
      const separator = item.separator || ','

      // 空值处理
      if (!formValue || formValue === '' || (Array.isArray(formValue) && formValue.length === 0)) {
        return []
      }

      try {
        switch (outputFormat) {
        case 'string':
          // "1,2,3" → ['1', '2', '3']
          if (typeof formValue === 'string') {
            return formValue.split(separator).filter(item => item !== '')
          }
          break

        case 'array<object>':
          // [{id:1,name:'A'}, {id:2,name:'B'}] → ['1', '2']
          if (Array.isArray(formValue)) {
            const result = []
            for (let i = 0; i < formValue.length; i++) {
              const obj = formValue[i]
              if (obj && typeof obj === 'object') {
                // 优先使用id字段，其次strValue，最后value
                const value = obj.id || obj.strValue || obj.value
                if (value !== undefined && value !== null) {
                  result.push(String(value))
                }
              }
            }
            return result
          }
          break

        case 'array':
        default:
          // ['1', '2', '3'] → 直接返回（确保是字符串数组）
          if (Array.isArray(formValue)) {
            return formValue.map(item => String(item))
          }
          break
        }

        // 如果以上都不匹配，尝试智能解析
        if (Array.isArray(formValue)) {
          return formValue.map(item => String(item))
        } else if (typeof formValue === 'string') {
          return formValue.split(separator).filter(item => item !== '')
        }
      } catch (error) {
        console.warn('[JJForm noInForm] parseFormValueToSelectArray 解析失败:', formValue, error)
      }

      // 默认返回空数组
      return []
    },

    changeFile(i) {
      this.$emit('fileCallBack', {
        key: this.item['key'],
        val: i
      })
    },
    /**
     * @description: 获取下拉或者复选框组数据源
     * @param {*}
     * @return {*}
     */
    getAjaxOptions(query) {
      const { dataSourceCode, remote, options } = this.item
      const optionsSource = JSON.parse(sessionStorage.getItem(dataSourceCode))
      // 远程搜索 获取缓存的下拉列表
      if (remote && options && options.length > 0) {
        this.ajaxOptions = Array.isArray(options) ? options : []
      }
      // 如果是远程搜索 且传递的query为空 接口不调用
      if (remote && !query) {
        return false
      }

      // dataSourreId 数据源id 用于获取数据源 测试环境建的数据 在正式环境id会被更新掉
      // dataSourceCode 数据源code 用于取数据源
      if (!remote && optionsSource && Object.keys(optionsSource).length > 0) {
        this.ajaxOptions = Array.isArray(optionsSource) ? optionsSource : []
        return false
      }

      if (dataSourceCode) {
        EexcuteDataSource({ data_source_code: dataSourceCode, keyword_value: query || '' }).then(response => {
          if (+response.data.res_status_code === 0) {
            const listData = response.data.res_content || []
            !remote && sessionStorage.setItem(dataSourceCode, JSON.stringify(listData))
            this.$set(this.item, 'options', [])
            this.ajaxOptions = Array.isArray(listData) ? listData : []
            this.$set(this.item, 'options', Array.isArray(listData) ? listData : [])
          } else {
            this.$message.error(response.data.res_message)
          }
        })
      }
    },
    /**
     * @description: select change事件
     * @param {*} item
     * @param {*} val
     * @return {*}
     */
    itemChange(item, val) {
      if (val) {
        const { key } = item
        const options = this.ajaxOptions.length > 0 && this.ajaxOptions || item.options || []
        // 用来将下拉框数据name值
        if (options.length > 0) {
          const optionsArr = options.filter(item => item.strValue === val)
          item[key + '_keyNameValue'] = optionsArr.length > 0 ? optionsArr[0]['strKey'] : ''
        }
      }
      const itemEvents = item['events']
      // 有自定义change事件 继续执行
      if (itemEvents && Object.keys(itemEvents).length > 0 && 'changeEvent' in itemEvents) {
        const { change } = itemEvents
        if (change) {
          change(val, {
            itemInstance: item,
            formInstance: this.jjFormInstance
          })
        }
        return
      }
    },

    /**
     * @description: 增强的select change事件处理
     * 支持多选输出格式配置 (string/array/array<object>)
     * @author domiyong
     * @param {Object} item - 表单项配置
     * @param {*} val - 选中的值（select组件的原始值）
     */
    handleSelectChange(item, val) {
      // 检查是否配置了输出格式转换
      const outputFormat = item.outputFormat || 'string'
      const separator = item.separator || ','

      // 🎯 优化：单选情况，组件内部逻辑使用原始值，向外传递原始值
      if (!item.multiple) {
        this.itemChange(item, val) // 内部逻辑使用原始值
        this.$emit('input', val) // 单选无需转换，传递原始值
        return
      }

      // 🎯 优化：多选情况，组件内部逻辑使用原始值，向外传递转换值
      let convertedValue = val // 默认转换值等于原始值
      let enhancedEventData = null

      if (Array.isArray(val) && val.length > 0) {
        // 创建格式转换器
        const converter = createValueFormatConverter({
          separator: separator,
          defaultFormat: outputFormat
        })

        // 获取选项列表用于转换
        const options = this.ajaxOptions.length > 0 ? this.ajaxOptions : (item.options || [])

        // 构建选项映射 (Vue 2.5.17兼容写法) - 基于原始值
        const optionList = []
        for (let i = 0; i < options.length; i++) {
          const option = options[i]
          if (option && val.includes(option.strValue)) {
            optionList.push({
              id: option.strValue,
              name: option.strKey,
              // 保留原始选项的所有属性
              strValue: option.strValue,
              strKey: option.strKey,
              disabled: option.disabled
            })
          }
        }

        // 执行格式转换 - 生成要传递给父组件的值
        convertedValue = converter.convertFormat(
          val,
          optionList,
          outputFormat,
          {
            idField: 'id',
            nameField: 'name'
          }
        )

        // 构建增强的事件数据 - 基于原始值和转换值
        enhancedEventData = {
          value: convertedValue, // 格式化后的值
          rawIds: val, // 原始ID数组
          rawNames: optionList.map(item => item.name), // 原始名称数组
          selectedItems: optionList, // 完整选中项数据
          outputFormat: outputFormat, // 当前输出格式
          separator: separator // 分隔符
        }

        // 为array<object>格式提供完整的item信息
        if (outputFormat === 'array<object>' && optionList.length > 0) {
          enhancedEventData.fullItems = optionList.map(item => {
            // Vue 2.5.17兼容的对象展开
            const fullItem = {}
            for (const key in item) {
              if (Object.prototype.hasOwnProperty.call(item, key)) {
                fullItem[key] = item[key]
              }
            }
            return fullItem
          })
        }

        // 🎯 保存名称值映射 - 基于原始值进行处理
        const { key } = item
        if (optionList.length > 0 && key) {
          item[key + '_keyNameValue'] = optionList.map(option => option.name).join(separator)
        }
      }

      // 🎯 关键：仅在向外传递时使用转换值，确保formValue得到正确格式
      this.$emit('input', convertedValue)

      // 触发增强的change事件
      if (enhancedEventData) {
        this.emitEnhancedSelectChange(item, enhancedEventData)
      }

      // 检查是否有自定义change事件
      const itemEvents = item['events']
      if (itemEvents && Object.keys(itemEvents).length > 0 && 'changeEvent' in itemEvents) {
        const { change } = itemEvents
        if (change) {
          // 传递转换值和增强数据给自定义事件
          change(convertedValue, {
            itemInstance: item,
            formInstance: this.jjFormInstance,
            enhancedData: enhancedEventData // 增强事件数据
          })
        }
        return
      }

      // 🎯 组件内部逻辑使用原始值，保持组件状态一致性
      this.itemChange(item, val)
    },

    /**
     * @description: 发送增强的select change事件
     * @param {Object} item - 表单项配置
     * @param {Object} enhancedEventData - 增强的事件数据
     */
    emitEnhancedSelectChange(item, enhancedEventData) {
      // 发送到父组件的增强change事件
      this.$emit('enhanced-select-change', {
        itemKey: item.key,
        itemLabel: item.label,
        ...enhancedEventData
      })

      // 向上传递到JJForm组件
      if (this.jjFormInstance && this.jjFormInstance.$emit) {
        this.jjFormInstance.$emit('enhanced-select-change', {
          itemKey: item.key,
          itemLabel: item.label,
          ...enhancedEventData
        })
      }

      // 控制台输出便于调试 (生产环境可移除)
      if (process.env.NODE_ENV === 'development') {
        console.log(`[JJForm noInForm Select] Enhanced change event for ${item.key}:`, enhancedEventData)
      }
    }
  }
}
</script>
<style lang='scss' scoped>
.common-select-popper {
  max-width: 300px!important;
}
</style>
